<template>
    <div class="fw-account">
        <van-nav-bar :title="title" style="background-color: #EEEEEE;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div>
            <div class="acitem">
                <img src="./../../assets/wx.png" class="tb-img" v-if="userType!=3"/>
                <span v-if="user.gzhOpenid">消息通知:已授权</span>
                <span style="color: #2b94ff;cursor: pointer" v-if="!user.gzhOpenid" @click="toBdMsg">授权消息通知</span>
            </div>
            <div class="acitem">
                <img src="./../../assets/wx.png" class="tb-img" v-if="userType!=3"/>
                <span v-if="user.payOpenid">微信支付:已授权</span>
                <span style="color: #2b94ff;cursor: pointer" v-if="!user.payOpenid" @click="toBdPay">授权微信支付</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '账号设置',
                fwUser: {},
                deptId: '',
                token: '',
                userType:'',
                tabIndex: '',
                user: {},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.getFwUser()
        },

        methods: {
            async getFwUser() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwUser", data)
                this.user = res.user
                console.log(this.user )
            },
            toBdMsg() {
                if (!this.user.id) {
                    this.$notify({type: 'danger', message: '用户id为空'});
                    return;
                }
                this.$router.push('/userBdMsg?deptId=' + this.deptId + '&userId=' + this.user.id)
            },
            toBdPay() {
                if (!this.user.id) {
                    this.$notify({type: 'danger', message: '用户id为空'});
                    return;
                }
                this.$router.push('/userBdPay?deptId=' + this.deptId + '&userId=' + this.user.id)
            },
            onClickLeft() {
                this.$router.push('/my')
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-account {
        margin: 0 auto;
        height: 100%;
        background-color: #ffffff;
        position: relative;
        padding-top: 53px;
    }

    .fw-account-bg {

    }

    .tb-img {
        width: 30px;
        height: 30px;
    }

    .acitem {
        padding: 0 20px;
        font-size: 13px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
    }

    .acitem span {
        margin-left: 18px;
    }

</style>
